import { PropsWithChildren, ReactNode, useEffect, useState } from 'react';
import { useBrowser } from '../../../services/BrowserService';
import { TopNavigationBar } from '../../TopNavigationBar/TopNavigationBar';
import { SearchHeader } from '../SearchHeader';
import { SearchPromotionItem } from '../Suggestions/EmptySearchSuggestions/SearchPromotionResponse.type';
import { SearchHeaderContainer } from './HeaderLayout.styles';

type Props = PropsWithChildren<{
  placeholder?: string;
  disableSearch?: boolean;
  banner?: ReactNode;
  compactSearch?: boolean;
  onClearSearch?: VoidFunction;
  searchSpecialty?: SearchPromotionItem | null;
  showLoginDropdown?: boolean;
  showSearchExperiment?: boolean;
  topNavExperiment?: boolean;
  practitionerProfile?: boolean;
}>;

export const HeaderLayout = ({
  children,
  placeholder,
  disableSearch,
  compactSearch,
  onClearSearch,
  searchSpecialty,
  showLoginDropdown,
  topNavExperiment,
  banner,
  showSearchExperiment,
  practitionerProfile,
}: Props) => {
  const doc = useBrowser().window?.document;
  const bodyClassList = doc?.body?.classList;

  const bannerOn = bodyClassList?.contains('branch-banner-is-active') ? true : false;
  const [branchBanner, setBanner] = useState(bannerOn);

  useEffect(() => {
    const branchIframe = doc?.getElementById('branch-banner-iframe');

    const removeBanner = (evtTarget: Event): void => {
      if (evtTarget.target === branchIframe) {
        setBanner(false);
        doc?.body?.removeEventListener('DOMNodeRemoved', removeBanner, false);
      }
    };

    if (branchIframe) {
      setBanner(true);
      doc?.body?.addEventListener('DOMNodeRemoved', removeBanner, false);
    }

    return () => {
      doc?.body?.removeEventListener('DOMNodeRemoved', removeBanner, false);
    };
  }, [doc, bannerOn]);

  return (
    <SearchHeaderContainer showingBranchBanner={branchBanner}>
      {banner}
      {topNavExperiment && <TopNavigationBar />}
      <SearchHeader
        placeholder={placeholder}
        disableSearch={disableSearch}
        compactSearch={compactSearch}
        onClear={onClearSearch}
        searchSpecialty={searchSpecialty}
        showLoginDropdown={showLoginDropdown}
        showSearchExperiment={showSearchExperiment}
        hideLogo={topNavExperiment}
        practitionerProfile={practitionerProfile}
      />
      {children}
    </SearchHeaderContainer>
  );
};
